import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeadComponent } from './head/head.component';
import { MaterialAngularModule } from 'src/app/material-angular.module';
import { MenuComponent } from './menu/menu.component';
import { RouterModule } from '@angular/router';
import { MyCustomPaginatorIntl, TableComponent } from './table/table.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ErrorlistComponent } from './errorlist/errorlist.component';
import { ErrorlistInventComponent } from './errorlistInevent/errorlistInvent.component';
import { ListEquiposModelComponent } from './list-equipos-model/list-equipos-model.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import {MatChipsModule} from '@angular/material/chips';
import { PasswordEntryParametrizationComponent } from './password-entry-parametrization/password-entry-parametrization.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { PasswordInstructionsComponent } from './password-instructions/password-instructions.component';
import { ResetPasswordModalComponent } from './reset-password-modal/reset-password-modal.component';
import { PrimeNgModule } from '../ui/prime-ng/prime-ng.module';
import { MensajeBitacoraComponent } from './mensaje-bitacora/mensaje-bitacora.component';

@NgModule({
  declarations: [
    HeadComponent,
    MenuComponent,
    TableComponent,
    SpinnerComponent,
    ErrorlistComponent,
    ErrorlistInventComponent,
    ListEquiposModelComponent,
    PasswordEntryParametrizationComponent,
    ResetPasswordComponent,
    PasswordInstructionsComponent,
    ResetPasswordModalComponent,
    MensajeBitacoraComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialAngularModule,
    RouterModule,
    MaterialAngularModule,
    FormlyModule.forRoot(),
    ReactiveFormsModule,
    FormlyMaterialModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatStepperModule,
    MatDialogModule,
    MatTooltipModule,
    MatChipsModule,
    PrimeNgModule,
    MaterialAngularModule

  ],
  exports: [
    SpinnerComponent,
    TableComponent,
    MenuComponent,
    HeadComponent,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialAngularModule,
    ReactiveFormsModule,
    FormlyMaterialModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatStepperModule,
    MatDialogModule,
    MatTooltipModule,
    ListEquiposModelComponent,
    MatChipsModule,
    PasswordEntryParametrizationComponent,
    ResetPasswordComponent,
    ResetPasswordModalComponent,
    MensajeBitacoraComponent
  ],
  providers: [{provide: MatPaginatorIntl, useClass: MyCustomPaginatorIntl}],
})
export class ComponentsModule { }
